import { CirclesError } from './circles-error';

export class InvalidCircleIdError extends CirclesError {
	constructor() {
		super('The circle id is invalid or blank.');
	}
}
